<div class="numeric-input-container" [class]="'size-' + size">
  <input type="number" class="form-control text-center numeric-input" [value]="value" [min]="min" [max]="max"
    [step]="step" [disabled]="disabled" (input)="onValueChange($event)" (blur)="onValueChange($event)">
</div>